/* @flow */
import * as React from 'react';
import LinkedAccountsSettings from 'settings/components/LinkedAccountsSettings';
import LinkedAccountsSettingsContainers from 'settings/containers/LinkedAccountsSettingsContainer';

class LinkedAccountsSettingsView extends React.Component<{}, {}> {
  render() {
    return (
      <LinkedAccountsSettingsContainers>
        {({ sources, loading, link, unlink }) => (
          <LinkedAccountsSettings sources={sources} loading={loading} link={link} unlink={unlink} />
        )}
      </LinkedAccountsSettingsContainers>
    );
  }
}

export default LinkedAccountsSettingsView;
